export enum MarketplaceRequestStatus {
  UNREQUESTED = 'unrequested',
  REQUESTED = 'requested'
}

export enum ENTITLEMENT {
  TRIAL = 'trial', // individual access, granted right after signup
  PERSONAL = 'personal', // individual access, purchased by user
  TEAM_MEMBER = 'team_member', // individual access, granted by team owner and valid until the team subscription expired
  TEAM_OWNER = 'team_owner', // team management (ownership) access, purchased by team owner
  TEAM_ADMIN = 'team_admin', // team management (ownership) access, granted by team owner and valid until the team subscription expired
  TEAM_SIZE_5 = 'team_size_5', // purchased team size limit
  TEAM_SIZE_10 = 'team_size_10', // purchased team size limit
  TEAM_SIZE_15 = 'team_size_15', // purchased team size limit
  PRO = 'pro' // access to all features
}
